var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, } from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Icon } from '../Icon/index.js';
import { BadgeProvider, useBadge } from './BadgeContext.js';
export const Badge = forwardRef((props, ref) => {
    const { as, variant = 'primary', size = 'md', rounded = false, children, leadingIcon, trailingIcon, className } = props, rest = __rest(props, ["as", "variant", "size", "rounded", "children", "leadingIcon", "trailingIcon", "className"]);
    const colorClsx = [
        variant === 'primary' && 'bg-action-primary-subdued text-content-primary',
        variant === 'secondary' && 'bg-surface-pressed text-content-subdued',
        'focus:outline-none focus-visible:ring',
    ];
    const sizeClsx = [
        size === 'xs' && 'px-1.5 text-xs',
        size === 'sm' && 'px-1.5 py-0.5 text-xs',
        size === 'md' && 'px-2.5 py-0.5 text-xs',
        size === 'lg' && 'px-3 py-0.5 text-sm',
    ];
    const roundedClsx = {
        rounded: !rounded && size === 'md',
        'rounded-sm': !rounded && (size === 'sm' || size === 'xs'),
        'rounded-md': !rounded && size === 'lg',
        'rounded-full ': rounded,
    };
    let leadingIconElement;
    if (leadingIcon) {
        const iconClsx = [
            size === 'md' && !!children && '-ms-0.5 me-1.5',
            size === 'lg' && !!children && '-ms-1 me-1.5',
            'h-4 w-4',
        ];
        leadingIconElement = (React.createElement(Icon, { className: clsx(iconClsx, colorClsx) }, leadingIcon));
    }
    let trailingIconElement;
    if (trailingIcon) {
        const iconClsx = [
            size === 'md' && !!children && '-me-0.5 ms-1.5',
            size === 'lg' && !!children && '-me-1 ms-1.5',
            'h-4 w-4',
        ];
        trailingIconElement = (React.createElement(Icon, { className: clsx(iconClsx, colorClsx) }, trailingIcon));
    }
    const Component = as || 'span';
    return (React.createElement(Component, Object.assign({ ref: ref, className: twMerge(clsx('inline-flex items-center', 'font-medium', colorClsx, sizeClsx, roundedClsx, className)) }, rest),
        React.createElement(BadgeProvider, { variant: variant, size: size },
            leadingIconElement,
            children,
            trailingIconElement)));
});
const BadgeButton = props => {
    const { children, className, disabled = false } = props, rest = __rest(props, ["children", "className", "disabled"]);
    const { variant } = useBadge();
    const buttonColorClsx = [
        'focus:outline-none',
        disabled && 'opacity-60 cursor-default pointer-events-none',
        variant === 'primary' && [
            'text-content-primary bg-action-primary-subdued focus:bg-action-primary-subdued-focused',
            !disabled &&
                'hover:bg-action-primary-subdued-hovered hover:text-content-primary',
        ],
        variant === 'secondary' && [
            'text-content-subdued bg-surface-subdued focus:outline-none focus:bg-surface focus:text-content-subdued',
            !disabled && ' hover:bg-surface-hovered hover:text-content-hovered',
        ],
    ];
    return (React.createElement("button", Object.assign({ type: "button", className: clsx('flex-shrink-0 ms-1 h-4 w-4 rounded-full inline-flex items-center justify-center focus:outline-none', buttonColorClsx, className), disabled: disabled }, rest), children));
};
Badge.Button = BadgeButton;
//# sourceMappingURL=Badge.js.map